import { FC, useMemo } from 'react'
import SvgIcon from 'components/atoms/SvgIcon'
import styles from 'components/features/coaching/advisorVideoCall/StreamControlPreset/StreamControlPreset.styl'
import { getSvgByFilename } from 'helpers/mediaHelpers'
import { ReactNode } from 'react-redux'
import cn from 'classnames'
import Spinner from 'components/features/pfm/Spinner/Spinner'

export const CONTROL_ON = 'on' as const
export const CONTROL_OFF = 'off' as const

export type ControlState =
  | typeof CONTROL_ON
  | typeof CONTROL_OFF

type StreamControlPresetProps = {
  isFullScreen?: boolean
  isDisabled?: boolean
  isProgress?: boolean
  onIconSlug: string
  offIconSlug: string
  state: ControlState
  meter?: ReactNode | null
  status: ReactNode | null
  onClick?: () => void
}
export const StreamControlPreset: FC<StreamControlPresetProps> = (props) => {
  const { onIconSlug, offIconSlug, state, meter, children, status, onClick, isFullScreen, isDisabled, isProgress } = props

  const { enabledIconChild, disabledIconChild } = useMemo(() => ({
    enabledIconChild: (<SvgIcon src={ getSvgByFilename(onIconSlug) } />),
    disabledIconChild: (<SvgIcon src={ getSvgByFilename(offIconSlug) } />),
  }), [onIconSlug, offIconSlug])

  const iconChild = useMemo(() => {
    if (state === 'on') {
      return enabledIconChild
    }
    return disabledIconChild
  }, [disabledIconChild, enabledIconChild, state])

  const className = useMemo(() => cn(
    styles.streamControlPreset,
    styles[state],
    isDisabled && styles.disabled,
    isProgress && styles.progress,
    isFullScreen && styles.fullScreen
  ), [isDisabled, isFullScreen, state, isProgress])

  return (
    <div className={ className }>
      <button className={ styles.button } onClick={ onClick }>
        { iconChild }
        { isProgress && (
          <div className={ styles.progressOverlay }>
            <Spinner />
          </div>
        )}
      </button>
      { meter && (
        <div className={ styles.meter }>
          { meter }
        </div>
      )}
      <div className={ styles.right }>
        <div className={ styles.content }>
          { children }
        </div>
        <div className={ styles.status } onClick={ onClick }>
          { status }
        </div>
      </div>
    </div>
  )
}
